import { combineReducers } from 'redux'
import authReducer from './authReducer'
import playlistReducer from './playlistsReducer'

const rootReducer = combineReducers({
    auth: authReducer,
    playlists: playlistReducer
})

export default rootReducer